import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { CoupletContext } from './App';

function Home() {
  let history = useHistory();
  const [inputCouplet, setInputCouplet] = useState("");
  const [couplet, setCouplet] = useContext(CoupletContext);
  const [showMsg, setShowMsg] = useState(false);
  const [message, setMessage] = useState("");
  const fixed_dict = {
    '自强成就卓越': ['创新塑造未来'],
    '自强不息': ['厚德载物'],
    '致知穷理': ['学问笃实', '学古探微'],
    '西山苍苍': ['东海茫茫'],
    '吾校庄严': ['岿然中央'],
    '大同爰跻': ['祖国以光'],
    '春风化雨乐未央': ['行健不息须自强'],
    '新旧合冶': ['殊途同归'],
    '肴核仁义': ['闻道日肥'],
    '海能卑下众水归': ['学问笃实生光辉'],
    '清华大学': ['桃李名园'],
    '天行健君子以自强不息': ['地势坤君子以厚德载物'],
    '天行健 君子以自强不息': ['地势坤 君子以厚德载物'],
    '天行健，君子以自强不息': ['地势坤，君子以厚德载物'],
    '天行健,君子以自强不息': ['地势坤,君子以厚德载物']
  };

  function handleInputChange(e) {
    setInputCouplet(e.target.value);
  };
  function scrollWindow() {
    console.log("onBlur");
    window.scrollTo(0, 0);
  };

  function handleSubmit() {
    console.log(inputCouplet);
    setShowMsg(true);
    setMessage("请您稍等...");
    if (inputCouplet.length > 15 || inputCouplet.length <=0) {
      // no more than 15 characters
      setMessage("抱歉，您的输入长度不合规范(应为1-15字)，您可另出一上联");
    } else if (fixed_dict[inputCouplet] !== undefined) {
      var fixed_list = fixed_dict[inputCouplet];
      var second_couplet = "";
      if (fixed_list.length === 1) {
        second_couplet = fixed_list[0];
      } else {
        second_couplet = fixed_list[Math.floor((Math.random()*fixed_list.length))];
      }
      setTimeout(()=>{
        setCouplet({
          'first_couplet': inputCouplet, 
          'second_couplet': second_couplet
        });
        console.log(couplet);
        setShowMsg(false);
        history.push('/showCouplet');
      }, 600);
    } else {
      // send input Couplet to server
      var data_first_couplet = {
        'first_couplet': inputCouplet
      };
      axios.post(process.env.REACT_APP_BACKEND_IP + '/getcouplet', JSON.stringify(data_first_couplet))
        .then(function (response) {
            // console.log(response);
            // success get couplet id
            var code = response.data.code;
            var celery_id = response.data.celery_id;
            if (code === '0') {
              var data_celery_id = {
                'celery_id': celery_id
              };
              var a = setInterval(function() {
                axios.post(process.env.REACT_APP_BACKEND_IP + '/sendcouplet', JSON.stringify(data_celery_id))
                  .then(function (response) {
                    // success get couplet
                    var status = response.data.status;
                    var couplet2 = response.data.couplet;
                    if (status === 'SUCCESS') {
                      setCouplet({
                        'first_couplet': inputCouplet, 
                        'second_couplet': couplet2
                      });
                      console.log(couplet);
                      setShowMsg(false);
                      clearInterval(a);
                      history.push('/showCouplet');
                    } else if (status === 'FAILED') {
                      // failed to get couplet
                      setMessage("出错了，请重试...");
                      clearInterval(a);
                    } else if (status === 'NOOUTPUT') {
                      // failed to get couplet
                      setMessage("抱歉，对您出的这个上联，我江郎才尽了。您可另出一上联");
                      clearInterval(a);
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    // get couplet failed
                    setMessage("出错了，请重试...");
                    clearInterval(a);
                  })
              }, 500);
            } else {
              // input error
              setMessage("出错了，请重试...");
            }
        })
        .catch(function (error) { 
            console.log(error);
            // getCouplet id failed
            setMessage("出错了，请重试...");
        })
    }
  };

  const inputEle = (
    <div className="container h-3/5 md:h-2/3 mx-auto flex grid gap-5 place-content-center">
      <div className="relative place-self-center p-10">
        <img className="inline w-32 h-32 md:w-52 md:h-52" src="../images/AIJiugeLogo.png" alt="" />
        &nbsp;&nbsp;
        <img className="inline w-32 h-16 md:w-52 md:h-24" src="../images/duiduiziLogo.png" alt="" />
      </div>
      <h1 className="font-bold text-xl md:text-3xl text-yellow-400 place-self-center">请您出上联:</h1>
      <input className="w-11/12 md:h-16 place-self-center shadow appearance-none border rounded text-xl py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
          id="input" type="text" placeholder="输入字数最好不超过15个" onChange={e => handleInputChange(e)} onBlur={scrollWindow}/>
      <button className="focus:outline-none w-11/12 place-self-center py-2 pl-12 rounded-2xl"
          onClick={handleSubmit} >
          <img className="inline w-56 h-16 md:w-64 md:h-20" src="../images/btnDXL.png" alt="对下联"/>
      </button>
      <p className="whitespace-pre-line text-center w-11/12 text-xl md:text-2xl text-yellow-400 place-self-center" hidden={!showMsg}>{message}</p>
    </div>
  );


  const footer = (
    <div>
      <div className="fixed inset-x-0 bottom-0 text-center h-auto md:h-36 md:text-xl bg-white">
          <br />
          <p>清华大学</p>
          <p>自然语言处理实验室</p>
          <p>九歌: <a href="http://jiuge.thunlp.org">jiuge.thunlp.org</a></p>
          <br />
      </div>
      <img className="fixed bottom-3 md: bottom-5 left-1 md:left-12 w-20 h-20 md:w-28 md:h-28" src="../images/qrJiuge.png" alt='九歌二维码'/>
      <img className="fixed bottom-3 md: bottom-5 right-1 md:right-12 w-20 h-20 md:w-28 md:h-28" src="../images/qrTHUNLP.jpg" alt='THUNLP公众号二维码' />
    </div>
  );

  return (
    <div className="w-screen mx-auto h-screen" style={{backgroundImage: "url('../images/bg1Pure.jpg')", backgroundSize: "cover"}}>
      <img className="fixed right-0 top-0 w-16 h-8 md:w-56 md:h-32" src="../images/leaf.png" alt="" />
      <img className="fixed bottom-32 md:bottom-40 left-2 w-24 h-12 md:w-56 md:h-28" src="../images/bull2021.png" alt="" />
      <img className="invisible md:visible fixed left-0 top-32 w-18 h-24 md:w-40 md:h-52" src="../images/lantern.png" alt="" />
      <a className="fixed bottom-32 md:bottom-40 right-2" href="http://jiuge.thunlp.org">
        <img className="w-8 md:w-20 h-14 md:h-36" src="../images/jiugeLogoGold.png" alt="" />
      </a>
      {inputEle}
      {footer}
    </div>
  )
};

export default Home;